import { useQuery } from '@tanstack/react-query';
import { getOptionItemsByGroup } from './option-items';

export function useOptionItemsByGroup(optionGroupId: number | undefined) {
    return useQuery({
        queryKey: ['getOptionItemsByGroup', optionGroupId],
        queryFn: () => getOptionItemsByGroup(optionGroupId!),
        enabled: !!optionGroupId,
    });
}
